import { Add } from '@mui/icons-material'
import React from 'react'

export const AddIcon = ({ onClick }) => {
    return (
        <Add onClick={onClick} style={{ color: '#88c2f3', cursor: 'pointer' }} />
    )
}
